import { mergeDeep } from '@apollo/client/utilities';
import { StrictTypedTypePolicies } from '@storefront/data-commerce';

export const mergeTypePolicies = (
  policies: StrictTypedTypePolicies[]
): StrictTypedTypePolicies => mergeDeep(...policies);

const generateIdentifyer = (s: string) =>
  Math.abs(
    s.split('').reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);

      return a & a;
    }, 0)
  ).toString();

export const getTypePoliciesVersion = (policies: StrictTypedTypePolicies[]) =>
  generateIdentifyer(JSON.stringify(policies));
